module.exports = __webpack_public_path__ + "img/ydgy.aa0c41f1.png";